import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

import { useNavigate } from "react-router-dom";
import { filter } from "lodash";
import { Tooltip } from "bootstrap";
import toast from "react-hot-toast";
import api from "../../../utils/api";

const base_url = process.env.REACT_APP_API_URL;
const SECRET_KEY = "yourSuperSecret123";

const AdminHome = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
    const [activeTab1, setActiveTab1] = useState("Cricket");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [cricket, setCricket] = useState([]);
    const [soccer, setSoccer] = useState([]);
    const [tennis, setTennis] = useState([]);
    const [tennislenght, setTennisLenght] = useState(0);
    const [cricketlenght, setCricketLength] = useState(0);
    const [footballlenght, setSoccerLength] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showAllInplay, setShowAllInplay] = useState(false);
    const [selectedInplayCategory, setSelectedInplayCategory] = useState(null);
    const [lockStates, setLockStates] = useState({});
    const [matches, setMatches] = useState([]);
    const [lockedMatch, setLockedMatch] = useState([]);
    const [lockedFancyMatch, setLockedFancyMatch] = useState([]);



    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
            new Tooltip(el);
        });
    }, []);


    const matchData = async () => {
        try {
            const encodedKey = btoa(SECRET_KEY);
            setIsLoading(true);
            const auth = localStorage.getItem("admin");
            const response = await api.get("/api/webapi/matchapi", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${auth}`,
                },
            });
const today = new Date();
today.setHours(0, 0, 0, 0); // midnight (start of today)

const filteredMatches = response?.data.result.matches
  .filter((match) => {
    const matchDate = new Date(match.openDate);
    return matchDate >= today; // today + future only
  })
  .sort((a, b) => new Date(a.openDate) - new Date(b.openDate)); // sort ascending

setCricket(filteredMatches);

            setCricketLength(filteredMatches?.length);
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const footballData = async () => {
        try {
            const encodedKey = btoa(SECRET_KEY);
            setIsLoading(true);
            const auth = localStorage.getItem("admin");
            const response = await api.get("/api/webapi/footballapi", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${auth}`,
                },
            });
const today = new Date();
today.setHours(0, 0, 0, 0); // midnight (start of today)

const filteredMatches = response?.data.result.matches
  .filter((match) => {
    const matchDate = new Date(match.openDate);
    return matchDate >= today; // today + future only
  })
  .sort((a, b) => new Date(a.openDate) - new Date(b.openDate)); // sort ascending

setSoccer(filteredMatches);

            setSoccerLength(filteredMatches?.length);
            // setSoccer(response?.data.result.matches);
            // setSoccerLength(response?.data?.result?.matches.length);
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const tennisData = async () => {
        try {
            const encodedKey = btoa(SECRET_KEY);
            setIsLoading(true);
            const auth = localStorage.getItem("admin");
            const response = await api.get("/api/webapi/tennisapi", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${auth}`,
                },
            });

            // console.log("response is ", response?.data.result.matches);

            const today = new Date();
today.setHours(0, 0, 0, 0); // midnight (start of today)

const filteredMatches = response?.data.result.matches
  .filter((match) => {
    const matchDate = new Date(match.openDate);
    return matchDate >= today; // today + future only
  })
  .sort((a, b) => new Date(a.openDate) - new Date(b.openDate)); // sort ascending

setTennis(filteredMatches);

            setTennisLenght(filteredMatches?.length);

            // setTennis(response?.data.result.matches);
            // setTennisLenght(response?.data?.result?.matches.length);
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        matchData();
        footballData();
        tennisData();
    }, []);

    useEffect(() => {
        if (!showAllInplay) {
            if (activeTab1 === "Cricket") matchData();
            else if (activeTab1 === "Soccer") footballData();
            else if (activeTab1 === "Tennis") tennisData();
        }
    }, [activeTab1, showAllInplay]);

    function formatToIST(utcDateStr) {
        const date = new Date(utcDateStr);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    }

    const handleClick = (item) => {
        sessionStorage.clear();
        sessionStorage.setItem("marketId", item.marketId);
        sessionStorage.setItem("competetionid", item.competitionId);
        sessionStorage.setItem("eventid", item.eventId);
        sessionStorage.setItem("time", item?.openDate);
        sessionStorage.setItem("competitionname", item?.competitionName);
        sessionStorage.setItem("eventname", item?.eventName);

        if (item.sportName === "Cricket") {
            navigate("/admin/homecricket");
            sessionStorage.setItem("selectionid1", item?.matchRunners[0].selectionId);
            sessionStorage.setItem("selectionid2", item?.matchRunners[1].selectionId);
            sessionStorage.setItem("runner1", item.matchRunners[0].runnerName);
            sessionStorage.setItem("runner2", item.matchRunners[1].runnerName);
            if (item?.matchRunners.length === 3) {
                sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
                sessionStorage.setItem("runner3", item.runners[2].runnerName);
            }
        } else if (item.sportName === "Soccer") {
            navigate("/admin/homefootball");
            sessionStorage.setItem("selectionid1", item?.matchRunners[0].selectionId);
            sessionStorage.setItem("selectionid2", item?.matchRunners[1].selectionId);
            sessionStorage.setItem("selectionid3", item?.matchRunners[2].selectionId);
            sessionStorage.setItem("runner1", item.matchRunners[0].runnerName);
            sessionStorage.setItem("runner2", item.matchRunners[1].runnerName);
            sessionStorage.setItem("runner3", item.matchRunners[2].runnerName);
        } else if (item.sportName === "Tennis") {
            navigate("/admin/hometennis");
            sessionStorage.setItem("selectionid1", item?.matchRunners[0].selectionId);
            sessionStorage.setItem("selectionid2", item?.matchRunners[1].selectionId);
            sessionStorage.setItem("runner1", item.matchRunners[0].runnerName);
            sessionStorage.setItem("runner2", item.matchRunners[1].runnerName);
            if (item?.matchRunners.length === 3) {
                sessionStorage.setItem("selectionid3", item?.matchRunners[2].selectionId);
                sessionStorage.setItem("runner3", item.matchRunners[2].runnerName);
            }
        }
    };

    const getLockMatch = async () => {
        try {
            const response = await api.get("/api/admin/getLockedMatches");
            console.log("response locked matches ", response?.data?.lockedMatch)
            setLockedMatch(response?.data?.lockedMatch);

            console.log("locked  atches ", lockedMatch);

        } catch (err) {

            toast.error("some thing went Wrong")

        }
    }

    const getFancyLockMatch = async () => {
        try {
            const response = await api.get("/api/admin/getLockedFancyMatches");
            console.log("response locked matches ", response?.data?.lockedMatch)
            setLockedFancyMatch(response?.data?.lockedMatch);

            console.log("locked  atches ", lockedMatch);

        } catch (err) {
            toast.error("some thing went Wrong")
        }
    }

    useEffect(() => {
        getLockMatch()
        getFancyLockMatch()

    }, [])

    const toggleLockMatch = async (newStatus, eventid) => {
        try {
            // Optimistically update the UI
            // setLockStates(prev => ({
            //   ...prev,
            //   [eventid]: newStatus
            // }));

            const response = await api.post(
                "/api/admin/lockhomeMatch",
                { newStatus, eventid },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data.success) {

                toast.success(response?.data.message);
                // Update the matches state to reflect the change
                getLockMatch();
            } else {

                toast.error(response?.data.message);
                getFancyLockMatch();
            }
        } catch (error) {
            // Revert the optimistic update if API call failed

            console.error("Error locking match", error);
            toast.error("Error updating match status");
        }
    };

    const toggleFancyLockMatch = async (newStatus, eventid) => {
        try {


            const response = await api.post(
                "/api/admin/lockfancyhomeMatch",
                { newStatus, eventid },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data.success) {

                toast.success(response?.data.message);
                // Update the matches state to reflect the change
                getFancyLockMatch();
            } else {
                // Revert the optimistic update if API call failed

                toast.error(response?.data.message);
                getFancyLockMatch();
            }
        } catch (error) {
            // Revert the optimistic update if API call failed

            console.error("Error locking match", error);
            toast.error("Error updating match status");
        }
    };


    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            if (!mobile) setIsSidebarOpen(true);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <div className="wrapper">
                {/* <AdminSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} isMobile={isMobile} />
                <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} /> */}

                <div className={`content-wrapper ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"}`} style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0", transition: "margin-left 0.3s ease" }}>
                    <div className="container-fluid m-2">
                        <h5>Home Page</h5>
                    </div>

                    <section className="content">
                        <div className="mt-2 h-3 tophead d-flex justify-content-between flex-wrap">
                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                <button className={`btn btn-sm btn-dark no-hover`} onClick={() => { setShowAllInplay(!showAllInplay); setSelectedInplayCategory(null); }} style={{ height: "2.5rem", marginTop: "0" }}>
                                    {showAllInplay ? "Show All Matches" : "Show Inplay Matches"}
                                </button>

                                {!showAllInplay && ["Cricket", "Tennis", "Soccer", "Horse Racing", "Greyhound Racing", "kabaddi", "Politics", "Casino", "ICasino"].map((sport) => {
                                    let length = sport === "Cricket" ? cricketlenght : sport === "Tennis" ? tennislenght : sport === "Soccer" ? footballlenght : '';
                                    return (
                                        <div key={sport} className={`p-2 mid d-flex align-items-center ${activeTab1 === sport ? "bg-dark text-white" : ""}`} style={{ cursor: "pointer", marginRight: "10px", borderRadius: "5px" }} onClick={() => setActiveTab1(sport)}>
                                            <div className="d-inline-block position-relative" style={{ minWidth: "60px" }}>
                                                <div>{sport}</div>
                                                {length ? (
                                                    <div className="text-danger position-absolute" style={{ top: 0, right: 0, fontSize: "0.75rem", fontWeight: "bold", borderRadius: "50%", padding: "2px 6px", lineHeight: "1", transform: "translate(50%, -50%)", backgroundColor: "#f8d7da" }}>
                                                        {length}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </section>

                    <div className="m-3">
                        <input type="text" placeholder="Enter event or match name" className="form-control mb-3" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value.toLowerCase())} />

                        {showAllInplay && (
                            <div className="d-flex gap-2 mb-3">
                                {["Cricket", "Soccer", "Tennis"].map((sport) => (
                                    <button
                                        key={sport}
                                        className={`btn btn-sm ${selectedInplayCategory === sport ? "btn-dark" : "btn-outline-dark"}`}
                                        onClick={() => setSelectedInplayCategory(sport)}
                                    >
                                        {sport}
                                    </button>
                                ))}
                            </div>
                        )}

                        {(() => {
                            let data = [];
                            console.log("data", data)
                            if (showAllInplay && selectedInplayCategory) {

                                console.log("showAllInplay", showAllInplay)
                                console.log("selectedInplayCategory", selectedInplayCategory)

                                let categoryData = [];

                                if (selectedInplayCategory === "Cricket") categoryData = cricket;
                                else if (selectedInplayCategory === "Soccer") categoryData = soccer;
                                else if (selectedInplayCategory === "Tennis") categoryData = tennis;
                                console.log("category Data is ", categoryData);
                                data = categoryData
                                    .filter((item) => new Date() >= new Date(item?.openDate))
                                    .map((item) => ({ ...item, game: selectedInplayCategory }));
                            } else if (!showAllInplay) {
                                if (activeTab1 === "Cricket") data = cricket;
                                else if (activeTab1 === "Soccer") data = soccer;
                                else if (activeTab1 === "Tennis") data = tennis;
                            }

                            const filteredData = data.filter(
                                (item) =>
                                    item?.eventName?.toLowerCase().includes(searchTerm) ||
                                    item?.competitionName?.toLowerCase().includes(searchTerm)
                            );

                            console.log("filterd data is ", filteredData);
                            console.log("data ", data);



                            if (filteredData.length > 0) {
                                return (
                                    <div className="d-flex flex-column gap-2">
                                        {filteredData.map((item, index) => (
                                            <div
                                                key={index}
                                                className="d-flex align-items-start p-2 justify-content-sm-between"
                                                style={{ borderBottom: "1px solid #dee2e6", backgroundColor: "#fff", borderRadius: "4px" }}
                                            >
                                                {/* <img
                          src="/assets/images/lock-icon2.png"
                          alt="lock"
                          style={{ height: "30px", marginRight: "5px", marginTop: "4px" }}
                        /> */}
                                                <div style={{ cursor: "pointer" }} onClick={() => handleClick(item)}>
                                                    <div style={{ fontSize: "13px", color: "#DC3545", display: "flex", alignItems: "center", gap: "5px" }}>
                                                        {new Date() >= new Date(item?.openDate) ? (
                                                            <>
                                                                <i className="bi bi-broadcast fs-6 live-blink" style={{ color: "#DC3545" }}></i>
                                                                <span style={{ fontWeight: "bold" }}>Live</span>
                                                            </>
                                                        ) : (
                                                            <span style={{ color: "#000" }}>{formatToIST(item?.openDate)}</span>
                                                        )}
                                                    </div>
                                                    <div style={{ fontWeight: "600", fontSize: "15px", color: "black" }}>
                                                        {item?.eventName}
                                                    </div>


                                                    {showAllInplay && (
                                                        <div style={{ fontSize: "12px", color: "#555" }}>
                                                            <strong>Game:</strong> {item?.sportName}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-end gap-3">
                                                    <button
                                                        className={`btn ${lockedMatch.some(m => m.eventid === item.eventId) ? "btn-success" : "btn-danger"}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title={lockedMatch.some(m => m.eventid === item.eventId) ? "Click To Unlock Match" : "Click to Lock Match"}
                                                        onClick={(e) => {
                                                            const isLocked = lockedMatch.some(m => m.eventid === item.eventId);
                                                            const newStatus = isLocked ? 1 : 2; // unlock if locked, lock if not
                                                            toggleLockMatch(newStatus, item.eventId);
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-lock"></i>
                                                    </button>


                                                    <button
                                                        className="btn btn-info"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Information"
                                                        onClick={() => handleClick(item)}
                                                    >
                                                        <i className="fa fa-info-circle"></i>
                                                    </button>

                                                    <button
                                                        className={`btn ${lockedFancyMatch.some(m => m.eventid === item.eventId) ? "btn-success" : "btn-danger"}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title={lockedFancyMatch.some(m => m.eventid === item.eventId) ? "Click To Unlock Fancy " : "Click to Lock Fancy"}
                                                        onClick={(e) => {
                                                            const isLocked = lockedFancyMatch.some(m => m.eventid === item.eventId);
                                                            const newStatus = isLocked ? 1 : 2; // unlock if locked, lock if not
                                                            toggleFancyLockMatch(newStatus, item.eventId);
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-lock"></i>
                                                    </button>

                                                    {/* <button 
    className="btn btn-warning" 
    data-bs-toggle="tooltip" 
    data-bs-placement="top" 
    title="Warning Info"
  >
    <i className="fa fa-info-circle"></i>
  </button> */}

                                                    <button
                                                        className="btn btn-warning"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Settings"
                                                        onClick={() => {
                                                            const delayState = {
                                                                eventid: item?.eventId,
                                                                name: item?.eventName,
                                                                marketid: item?.marketId,
                                                            };
                                                            localStorage.setItem("eventDelayData", JSON.stringify(delayState));
                                                            navigate("/admin/eventDelay", { state: delayState });
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-gear"></i>
                                                    </button>

                                                    {/* <button 
    className="btn btn-success" 
    data-bs-toggle="tooltip" 
    data-bs-placement="top" 
    title="Statistics"
  >
    <i className="fa fa-chart-line"></i>
  </button> */}
                                                </div>

                                            </div>
                                        ))}
                                    </div>
                                );
                            } else {
                                return <div className="text-center text-muted mt-3">No Match Found</div>;
                            }
                        })()}


                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminHome;